import { render, staticRenderFns } from "./PaginaFornecedor.vue?vue&type=template&id=c3c9ca8c&"
import script from "./PaginaFornecedor.vue?vue&type=script&lang=js&"
export * from "./PaginaFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports